import { GridState } from "@ag-grid-community/core";
import {
  Badge,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useTransactionsAssistantRequestCreate } from "gen/endpoints/transactions-ai/transactions-ai";
import { AIRequestDataRequest } from "gen/model/aIRequestDataRequest";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { HiOutlineSparkles } from "react-icons/hi";
import { ButtonOrder } from "shared/components/button/ButtonOrder";
import { FormCancelButton } from "shared/components/button/FormCancelButton";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import Form from "shared/components/form/Form";
import { FormTextArea } from "shared/components/input/text/TextArea";
import { useToast } from "shared/components/toast/useToast";

export const MaybernTransactionsAssistantModal: React.FC<{
  onCloseComplete: () => void;
  setAIState: (state: GridState | undefined) => void;
}> = ({ onCloseComplete, setAIState }) => {
  const { t } = useTranslation(["ai", "common"]);
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const { showErrorToast } = useToast();
  const { mutateAsync: createTransactionsAssistantRequest } =
    useTransactionsAssistantRequestCreate();
  const form = useForm<AIRequestDataRequest>();
  const onSubmit = async (data: AIRequestDataRequest) => {
    try {
      const response = await createTransactionsAssistantRequest({ data });
      setAIState(response as GridState);
      onCloseComplete();
    } catch (err) {
      showErrorToast(err);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={onCloseComplete}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text display="inline-block" mr={2}>
            {t("ai:transactions.name")}
          </Text>
          <Badge colorScheme="teal">{t("common:beta")}</Badge>
        </ModalHeader>
        <Form form={form} onSubmit={onSubmit} onSuccess={onClose}>
          <ModalBody>
            <Text mb={4}>{t("ai:transactions.description")}</Text>
            <FormTextArea name="request" title={t("ai:transactions.example")} />
          </ModalBody>
          <ModalFooter gap={2}>
            <ButtonOrder
              dismiss={<FormCancelButton onClick={onCloseComplete} />}
              confirm={
                <FormSubmitButton>
                  <Icon
                    height="16px"
                    width="16px"
                    as={HiOutlineSparkles}
                    color="gray.100"
                    mr="5px"
                  />
                  {t("ai:transactions.generate")}
                </FormSubmitButton>
              }
            />
          </ModalFooter>
        </Form>
      </ModalContent>
    </Modal>
  );
};
